<template>
  <div class="container">
    <TheLayout>
      <div class="body-container">
        <div class="user-container">
          <div class="user-details">
            <div class="user-avatar">
              <el-avatar
                :src="
                  (userInfo.image || {}).file_src
                    ? (userInfo.image || {}).file_src
                    : 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png'
                "
                :size="60"
              ></el-avatar>
              <p>{{ userInfo.name }}</p>
            </div>
            <div class="user-grandtotal">
              <div class="grandtotal-student">
                <p>{{ userInfo.grandtotal_student }}</p>
                <p>累计学生人次</p>
              </div>
              <div class="grandtotal-class">
                <p>{{ userInfo.educational_years }}</p>
                <p>累计授课时间/年</p>
              </div>
            </div>
            <div class="uesr-integral">
              <el-tooltip placement="bottom">
                <div slot="content">
                  <div>
                    <div class="container-text">线上积分获取规则</div>
                    <div class="container-text_desc">
                      <p>小程序发布动态：+10分/次</p>
                      <p>评论他人：+0.5分/次</p>
                      <p>打卡点赞：+0.2分/次</p>
                      <p>课程反馈圈子打卡内容被课程组采纳：+50分/次</p>
                      <p>培训课后测试60分以上：+30分/次</p>
                    </div>
                    <div class="container-text">线下活动积分获取规则</div>
                    <div class="container-text_desc">
                      <p>学生的诗被采诗组选中：+50分/次</p>
                      <p>投稿“时光故事”：+150分/次</p>
                      <p>推广新教师参加：+200分/人</p>
                      <p>活动方案投稿被录用：+50分/次</p>
                      <p>举办一场相关活动：+30~100分/次</p>
                      <p>活动举办成功后投稿被录用：+30~100分/次</p>
                    </div>
                  </div>
                </div>
                <p>当前积分: {{ userInfo.integral_score }}</p>
              </el-tooltip>
              <router-link :to="{ name: 'redeem_the_prize_list' }"
                ><el-button type="primary" size="mini"
                  >兑换奖品</el-button
                ></router-link
              >
            </div>
            <div class="user-grade">
              <p>当前星级：</p>
              <el-rate
                v-model="value"
                disabled
                text-color="#ff9900"
                score-template="{value}"
              >
              </el-rate>
            </div>
            <div class="user-prompt">
              <span>已订阅：{{ userInfo.subscribe }}</span
              >｜ <span>已下载：{{ userInfo.download }}</span
              >｜
              <span>已反馈：{{ userInfo.feedback }}</span>
            </div>
          </div>
          <div class="user-nav-list">
            <router-link
              :to="{ name: 'my_student_production' }"
              class="nav-list-item"
              :class="{ active: $route.name === 'my_student_production' }"
              >我的学生作品</router-link
            >
            <router-link
              :to="{ name: 'my_subscription' }"
              class="nav-list-item"
              :class="{ active: $route.name === 'my_subscription' }"
              >我的订阅</router-link
            >
            <router-link
              :to="{ name: 'my_feedback' }"
              class="nav-list-item"
              :class="{ active: $route.name === 'my_feedback' }"
              >我的反馈</router-link
            >
            <router-link
              :to="{ name: 'my_information' }"
              class="nav-list-item"
              :class="{ active: $route.name === 'my_information' }"
              >基本信息</router-link
            >
          </div>
          <div class="class-feedback">
            <router-link :to="{ name: 'feedback' }"
              ><el-button plain>填写课后反馈</el-button></router-link
            >
          </div>
        </div>
        <div class="show-container">
          <router-view />
        </div>
      </div>
    </TheLayout>
  </div>
</template>
<script>
import TheLayout from "./TheLayout";
import { mapState } from "vuex";
export default {
  data() {
    return {
      value: 4,
      userData: {
        download: 0,
        feedback: 0,
        image_url: "",
        integral: null,
        level: 0,
        name: "用户",
        student_count: "0",
        subscribe: 0,
        teacher_id: null,
        teaching_hours: "0.00"
      },
      userForm: {}
    };
  },
  components: {
    TheLayout
  },
  computed: {
    ...mapState(["userInfo"])
  },
  created() {
    this.userForm = this.userInfo;
  }
};
</script>
<style lang="less" scoped>
.container-text {
  line-height: 30px;
  border-bottom: 1px solid #fff;
  margin-bottom: 10px;
  .container-text_desc {
    padding: 10px;
  }
}
.container {
  height: 100%;
  width: 100%;
  .body-container {
    display: flex;
    max-width: 960px;
    margin: 0 auto;
    padding-top: 20px;
  }
  .user-container {
    width: 227px;
    font-size: 12px;
    color: #2c3e50;
  }
  .user-details {
    background: #ffffff;
    min-height: 360px;
    .user-avatar {
      height: 134px;
      padding: 30px;
    }
    .user-grandtotal {
      display: flex;
      justify-content: center;
      padding: 10px 10px 20px 10px;
      .grandtotal-student {
        padding: 10px 3px;
        margin: 0 10px 0 10px;
        width: 87px;
        height: 56px;
      }
      .grandtotal-class {
        padding: 10px 3px;
        margin: 0 10px 0 10px;
        width: 87px;
        height: 56px;
      }
    }
    .uesr-integral {
      display: flex;
      align-items: center;
      padding-left: 20px;
      p {
        margin-right: 20px;
      }
    }
    .user-grade {
      display: flex;
      padding-left: 20px;
      height: 32px;
      align-items: center;
    }
    .user-prompt {
      display: flex;
      padding: 20px 0 0 20px;
    }
  }
  .user-nav-list {
    margin-top: 20px;
    .nav-list-item {
      display: flex;
      text-decoration: none;
      align-items: center;
      text-align: left;
      padding-left: 20px;
      background: #ffffff;
      border-bottom: 1px solid #dedede;
      height: 40px;
      color: #2c3e50;
      cursor: pointer;
      &:hover {
        color: #fff;
        background: #f90;
        border-left: none !important;
      }
      &.active {
        border-left: 2px solid #f90;
      }
    }
  }
  .class-feedback {
    padding: 16px 0 30px 0;
    .el-button {
      width: 100%;
      height: 32px;
      font-size: 12px;
      font-weight: 400;
      padding: 0;
    }
  }
  .show-container {
    flex: 1;
    padding-left: 30px;
  }
}
</style>
